import { useGameStore } from '../state/useGameStore';
import type { FloatingDamage } from '../state/useGameStore';

export function resolveFloatingDamageStyle(amount: number, age: number) {
  const critical = amount >= 50;
  return {
    critical,
    opacity: Math.max(0, 1 - age / 1.8),
    fontSize: critical ? 24 : 18,
    color: critical ? '#ff4422' : '#ffdd44',
    translateY: -age * 60,
  };
}

export function FloatingDamages() {
  const floatingDamages = useGameStore((s) => s.floatingDamages);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 200,
      }}
    >
      {floatingDamages.map((entry: FloatingDamage) => {
        const style = resolveFloatingDamageStyle(entry.amount, entry.age);
        return (
          <div
            key={entry.id}
            style={{
              position: 'absolute',
              left: `${entry.x * 100}%`,
              top: `${entry.y * 100}%`,
              transform: `translate(-50%, -50%) translateY(${style.translateY}px)`,
              opacity: style.opacity,
              fontSize: style.fontSize,
              color: style.color,
              fontWeight: style.critical ? 900 : 700,
              fontFamily: 'monospace',
              textShadow: style.critical ? '0 0 8px #ff4422' : undefined,
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {entry.amount}
          </div>
        );
      })}
    </div>
  );
}
